import axios from "axios";
import apiConfig from "@/config/api.config";
import { requestInterceptor, responseInterceptor } from "./api-interceptors";

/**
 * Creates an instance of the axios which will be used to send api calls
 * throughout the application
 */
export const $http = axios.create({
  baseURL: apiConfig.API_BASE_URL,
});

/**
 * Intercepts all the api requests
 * * @todo Integerate the request interceptors
 */
$http.interceptors.request.use(requestInterceptor);

/**
 * Intercepts api response
 * @todo Integerate the response interceptors
 */
$http.interceptors.response.use(undefined, responseInterceptor);
